module.exports = __webpack_public_path__ + "static/media/flag-lb.0fe3d1ad.webp";